import { render } from "./YellowEditCompanyModal.vue?vue&type=template&id=16c60f31"
import script from "./YellowEditCompanyModal.vue?vue&type=script&lang=js"
export * from "./YellowEditCompanyModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__